// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { browserHistory } from "react-router";

import type { TokenStatesType } from "../types/UserFormType";
import { getUserInfo } from "../../global/actions/databaseActions";
import { ErrosDisplay, setErrorMsg } from "../../global/components/ErrosDisplay";
import LoadingProgress from "../../global/components/LoadingProgress";
import { ColorSchema } from "../../global/types/scss";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

class Token extends Component<*, TokenStatesType> {
  setLoadError: Function;
  constructor(props) {
    super(props);
    this.state = {
      errors: {}
    };
    this.setLoadError = this.setLoadError.bind(this);
  }

  componentDidMount() {
    if (this.props.params.token !== "" && this.props.db.conference.id !== undefined && this.props.db.user === undefined) {
      this.props.actions.getUserInfo(this.props.db.conference.id, this.props.params.token, this.props.params.conference, this.setLoadError);
    }
  }

  setLoadError(isActivated: boolean) {
    if (isActivated) {
      if(this.props.db.user.enrolments.length >= 2 && this.props.db.conference.active && this.props.db.conference.allow_user_searching && (this.props.location.query.page === undefined || this.props.location.query.page !== "profile")){
        browserHistory.replace("/" + this.props.params.conference + "/search");
      }
      else{
        browserHistory.replace("/" + this.props.params.conference + "/profile");
      }
    }
    else {
      this.setState({ errors: setErrorMsg(this.state.errors, "access_token", "Access Link is NOT valid.") });
    }
  }

  render(): React$Element<*> {
    const user = this.props.db.user;
    return (
      <div>
        <Typography variant="subheading" className="form-text hint-margin-bottom" style={{ color: ColorSchema("primary") }}>
          Checking Your Access Token...
        </Typography>
        <div className="top-banner">
          <ErrosDisplay errors={this.state.errors} form="user" />
        </div>
        <div className="form-text">
          <LoadingProgress size={100} />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { db: state.forensic.db };
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators({ getUserInfo }, dispatch) };
}

export default connect(mapStateToProps, mapDispatchToProps)(Token);


// WEBPACK FOOTER //
// ./src/conference/views/Token.js